"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const status_1 = require("../../constants/status");
const select_button_style_1 = __importDefault(require("./select.button.style"));
const icons_1 = require("../../../icons");
class SelectButton extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.handleClick = () => {
            if (!this.props.disabled)
                this.props.onClick();
        };
        this.render = () => {
            const { classes, id, children, hasValue, buttonRef, disabled, status, onFocus, onBlur, open } = this.props;
            const rootProps = {
                className: classes.root,
                id,
                onFocus,
                onBlur,
                onClick: this.handleClick,
                type: 'button',
                ref: buttonRef,
                disabled,
                'data-has-value': hasValue,
                'data-is-invalid': status === status_1.STATUS_INVALID,
                'data-is-open': open,
                'data-cy': 'atomic-dropdown-select'
            };
            const iconProps = {
                className: classes.icon,
                'data-is-open': open
            };
            return (jsx_runtime_1.jsxs("button", Object.assign({}, rootProps, { children: [jsx_runtime_1.jsx("span", Object.assign({ className: classes.value }, { children: children }), void 0),
                    jsx_runtime_1.jsx("span", Object.assign({}, iconProps, { children: jsx_runtime_1.jsx(icons_1.icons.ArrowDownFill, { size: 17 }, void 0) }), void 0)] }), void 0));
        };
    }
}
exports.SelectButton = SelectButton;
SelectButton.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    id: prop_types_1.default.string,
    children: prop_types_1.default.node.isRequired,
    onFocus: prop_types_1.default.func.isRequired,
    onBlur: prop_types_1.default.func.isRequired,
    onClick: prop_types_1.default.func.isRequired,
    hasValue: prop_types_1.default.bool.isRequired,
    buttonRef: prop_types_1.default.func.isRequired,
    open: prop_types_1.default.bool.isRequired,
    status: prop_types_1.default.oneOf([status_1.STATUS_INVALID]),
    disabled: prop_types_1.default.bool
};
SelectButton.defaultProps = {
    id: null,
    status: null,
    disabled: false
};
exports.default = react_jss_1.default(select_button_style_1.default)(SelectButton);
//# sourceMappingURL=select.button.js.map